import React, { useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined
} from '@ant-design/icons';
import { Button, Layout, Space, Dropdown, Avatar, Typography, DatePicker, Flex, Input } from 'antd';
import { HiOutlineUser, HiOutlineBell, HiOutlineArrowRightOnRectangle } from "react-icons/hi2";
import moment from 'moment';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;
const { Paragraph } = Typography;
const { Search } = Input;
const { RangePicker } = DatePicker;

const rangePresets = [
  {
    label: 'Last 7 Days',
    value: [dayjs().add(-7, 'd'), dayjs()],
  },
  {
    label: 'Last 14 Days',
    value: [dayjs().add(-14, 'd'), dayjs()],
  },
  {
    label: 'Last 30 Days',
    value: [dayjs().add(-30, 'd'), dayjs()],
  },
  {
    label: 'This Month',
    value: [dayjs().startOf('month'), dayjs().endOf('month')],
  },
  {
    label: 'Last Month',
    value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
  },
  {
    label: 'Last 12 Months',
    value: [dayjs().subtract(12, 'months'), dayjs()],
  },
  {
    label: 'This Year',
    value: [dayjs().startOf('year'), dayjs().endOf('year')],
  },
  {
    label: 'Custom Range',
    value: [null, null],
  },
  {
    label: 'All Time',
    value: [dayjs('0000-00-00'), dayjs()],
  },
];

const TopBar = ({ colorBgContainer, collapsed, setCollapsed, selectedKey, messageApi }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [customRange, setCustomRange] = useState([dayjs().add(-30, 'd'), dayjs()]);
  const key = 'updatable';
  const items = [
    {
      key: 'account',
      label: (
        <div style={{ minWidth: 300, display: 'flex', alignItems: 'center' }}>
          <Space direction="horizontal" size={16}>
            <Space wrap size={16}>
              <Avatar size={48} icon={<HiOutlineUser />} />
            </Space>
            <Paragraph style={{ marginTop: 10 }}>
              <b>Admin</b>
            </Paragraph>
          </Space>
        </div>
      ),
    },
    {
      key: 'your-account',
      label: <div className='topBarMenuHovers'><HiOutlineUser size={24} /> <span style={{ marginLeft: 10 }}>Your Account</span></div>,
      navigateto: '/account',
    },
    {
      key: 'logout',
      label: <div className='topBarMenuHoversLogout'><HiOutlineArrowRightOnRectangle size={24} /> <span style={{ marginLeft: 10 }}>Logout</span></div>,
      navigateto: '/logout',
    }
  ];

  const handleMenuClick = async (e) => {
    const selectedItem = items.find(item => item.key === e.key);
    if (selectedItem.key === 'logout') {
    messageApi.open({
      key,
      type: 'loading',
      content: 'Loading...',
    });
    const url = `${window.API_BASE_URL}/auth/adminlogout`;
    const token = localStorage.getItem('adminLoginToken');
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      console.log(response);
      if (response.ok) {
        setTimeout(() => {
          messageApi.open({
            key,
            type: 'success',
            content: 'Logout Successful!',
            duration: 2,
          });
          setTimeout(() => {
            localStorage.removeItem('adminLoginToken');
            localStorage.removeItem('adminDeviceId');
            window.location.reload();
          }, 300);
        }, 1000);
      } else {
        const data = await response.json();
        console.error('Logout failed:', data.message);
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  }else{
    if (selectedItem && selectedItem.navigateto) {
      navigate(selectedItem.navigateto);
    }
  }
  };

  const handleCustomRangeChange = (dates) => {
    if (dates) {
      setCustomRange(dates);
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    console.log(searchTerm);
  };

  return (
    <Header className='mainHeader' style={{ background: colorBgContainer }}>
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontSize: '18px',
          width: 64,
          height: 64,
        }}
      />
      <Space direction="vertical" style={{ width: '100%', padding: 24 }}>
        <Space className='topBarMenus'>
          <Flex align='center' justify='start' gap={16}>
            <Search placeholder="Search customers" onChange={(e) => handleSearch(e.target.value)} style={{ width: '100%', minWidth: 300, maxWidth: 500 }} />
          </Flex>
          <Flex align='center' justify='end' gap={16}>
            <RangePicker
              presets={rangePresets}
              value={customRange}
              onChange={handleCustomRangeChange}
              style={{ width: '100%' }}
              placeholder={['Start date', 'End date']}
              className='dateRangePicker'
            />
            <Button><HiOutlineBell size={24} /></Button>
            <Dropdown
              menu={{
                items: items.map(item => ({
                  ...item,
                  className: item.key === 'logout' ? 'topMenuDropdownsLogout' : 'topMenuDropdowns',
                })),
                onClick: handleMenuClick,
              }}
              placement="bottomLeft"
            >
              <Button><HiOutlineUser size={24} /></Button>
            </Dropdown>
          </Flex>
        </Space>
      </Space>
    </Header>
  );
};

export default TopBar;